<template>
    <q-layout view="hHh LpR fff">
        <div v-if="canPermisson">
            <!-- Navbar -->
            <q-layout-header reveal>
                <navbar @leftDrawerToogle="left = !left"></navbar>
            </q-layout-header>

            <!-- Left Side Panel -->
            <q-layout-drawer side="left" v-model="left" behavior="mobile">
                <v-menu></v-menu>
            </q-layout-drawer>

            <!-- Content -->
            <q-page-container>
                <child/>
            </q-page-container>

            <!-- Footer -->
            <q-layout-footer>
                <div style="padding: .5rem; background-color: #6D6D70" class="row items-center justify-between text-white">
                    <span>Version: {{ appVersion }}</span>
                    <span>Tecnologia PDM / &copy;2018 Philip Morris Limited</span>
                </div>
            </q-layout-footer>

            <!-- Helper tour -->
            <v-tour name="helpTour"></v-tour>
        </div>

        <div class="shadow-25 flex-center row window-height" v-if="!canPermisson">
            <div class="col-6">
                <v-header :title="$t('warning')" icon="settings"></v-header>
                <card width="100%">
                    <form @submit.prevent="upload" class="q-pt-xs gutter-xs row align-center">
                        <q-checkbox v-model="checkConfirmation">
                            {{ $T('I confirm that I have read the notification that tomorrow there will be a collection of used Lending devices.') }}
                        </q-checkbox>
                        <div class="row justify-center col-12 q-mt-md">
                            <v-button outline :label="$t('send')" icon="send" color="highlight"
                                class="no-shadow uppercase q-btn-iqos" :disabled="!checkConfirmation" type="button" @click="storeStockOrderCollect" />
                        </div>
                    </form>
                </card>
            </div>
        </div>
    </q-layout>
</template>

<script>
    import Navbar from '../components/Navbar'
    import VMenu from '../components/Menu'

    import axios from "axios";
    import { mapGetters } from 'vuex'

    import {
        QLayout,
        QLayoutHeader,
        QLayoutFooter,
        QLayoutDrawer,
        QPageContainer
    } from 'quasar-framework'

    export default {
        name: 'MainLayout',

        components: {
            Navbar,
            VMenu,
            QLayout,
            QLayoutHeader,
            QLayoutFooter,
            QLayoutDrawer,
            QPageContainer
        },

        computed: {
            ...mapGetters({
                user: 'auth/user'
            }),
        },
        mounted() {
            const that = this

            if(that.isUserPos()) {
                that.checkStockOrderCollect()

                const fiveMin = 5 * 60 * 1000

                setInterval(function() {
                    that.checkStockOrderCollect()
                }, fiveMin)
            }
        },

        data() {
            return {
                left: false,
                checkConfirmation: false,
                canPermisson: true,
                appVersion: window.config.appVersion,
            }
        },

        methods: {
            checkStockOrderCollect() { 
                const that = this
                that.checkConfirmation = false
                
                axios.get('/api/v1/check-stock-order-collect')
                    .then(response => {
                        const { stock_orders = 0 } = response.data
                        that.canPermisson = !stock_orders
                    });
            },
            storeStockOrderCollect() {
                const that = this
                axios.post('/api/v1/check-stock-order-collect')
                    .then(response => {
                        that.checkStockOrderCollect()
                    });
            },
            isUserPos() {
                return ['Lending Point', 'Lending Point Indirect', 'Lending Point Hostesses'].includes(this.user.role.name)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/layouts/default.vue